<template>
	<div v-if="isLandscape" class="landscape-notice">
		<p><img src="../assets/img/mobile-portrait-mode-icon.svg"><br>{{ t('txt_rotate_phone') }}</p>
	</div>
</template>

<script>
import { useI18n } from 'vue-i18n';
export default {
	data() {
		return {
			isLandscape: false,
		};
	},
	setup() {
		const { t } = useI18n();
		return {
			t
		};
	},
	mounted() {
		this.checkOrientation();
		window.addEventListener("resize", this.checkOrientation);
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkOrientation);
	},
	methods: {
		checkOrientation() {
			this.isLandscape = window.innerWidth > window.innerHeight;
		},
	}
};
</script>

<style scoped>
.landscape-notice {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(42, 46, 67, 0.9);
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	font-size: 1.5rem;
	text-align: center;
	img {
		padding: 15px;
	}
	p {
		max-width: 60%;
	}
}
body:has(.desktop-warning) .landscape-notice {
	display: none !important;
}
</style>